/* Fransk katalog for locale-journal-recovery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'journalRecovery.title': 'La comptabilité est temporairement indisponible',
  'journalRecovery.description': 'Le journal n\'a pas pu être vérifié. Les pages comptables et les modifications sont bloquées jusqu\'à la réussite du contrôle. Vous pouvez contacter le support ou changer d\'entreprise dans le menu.',
  'journalRecovery.reference': 'Entreprise : {businessId} · Exercice : {year}',
  'journalRecovery.retry': 'Réessayer',
  'journalRecovery.retrying': 'Vérification …',
  'journalRecovery.support': 'Contacter le support',
  'journalRecovery.signOut': 'Se déconnecter',
  'journalRecovery.writeBlocked': 'Le journal est indisponible. Réessayez avant de modifier la comptabilité.',
});
